export default "__VITE_ASSET__OHnE68zDsxVrAwzXN$bmCw__"